import { Button, Modal } from "@xola/ui-kit";
import React, { useState } from "react";
import { DigitalWaiver, Experience, SelectionState } from "types";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { DigitalWaiversExperiencesSelector } from "./DigitalWaiversExperiencesSelector";

interface DigitalWaiversExperiencesSelectorModalProps {
    isOpen: boolean;
    onClose: () => void;
    value: SelectionState;
    onConfirm: (value: SelectionState) => void;
    title?: string;
    description?: string;
    waiverTemplates: DigitalWaiver[];
    waiverTemplate: DigitalWaiver;
    experiences: Experience[];
}

export const DigitalWaiversExperiencesSelectorModal = ({
    isOpen,
    onClose,
    value,
    onConfirm,
    title = "Product Assignment",
    description,
    waiverTemplates,
    waiverTemplate,
    experiences,
}: DigitalWaiversExperiencesSelectorModalProps) => {
    return (
        <Modal isOpen={isOpen} size="huge" onClose={onClose}>
            <ModalContent
                value={value}
                title={title}
                description={description}
                waiverTemplates={waiverTemplates}
                waiverTemplate={waiverTemplate}
                experiences={experiences}
                onConfirm={onConfirm}
                onClose={onClose}
            />
        </Modal>
    );
};

interface ModalContentProps extends Omit<DigitalWaiversExperiencesSelectorModalProps, "isOpen"> {}

const ModalContent = ({
    onClose,
    value,
    onConfirm,
    title,
    description,
    waiverTemplates,
    waiverTemplate,
    experiences,
}: ModalContentProps) => {
    const [selectedProducts, setSelectedProducts] = useState<SelectionState>(value);

    const handleConfirmClick = () => {
        onConfirm(selectedProducts);
        onClose();
    };

    return (
        <>
            <Modal.Header description={description}>{title}</Modal.Header>

            <Modal.Body>
                <DigitalWaiversExperiencesSelector
                    value={value}
                    waiverTemplates={waiverTemplates}
                    waiverTemplate={waiverTemplate}
                    experiences={experiences}
                    onChange={setSelectedProducts}
                />
            </Modal.Body>

            <Modal.Footer className="space-x-4">
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>

                <Button onClick={handleConfirmClick}>Apply</Button>
            </Modal.Footer>
        </>
    );
};
